import React from "react";

const PrivacyPolicy = () => {
    return (
        <div style={styles.container}>
            <h1 style={styles.heading}>Privacy Policy</h1>
            <p style={styles.introText}>
                Welcome to our Privacy Policy page! Your privacy is critically important to us.
            </p>

            <section style={styles.section}>
                <h2 style={styles.sectionHeading}>1. Information We Collect</h2>
                <p style={styles.text}>
                    We collect personal information you provide to us, including your name, email address, and payment details, which are essential for providing our services.
                </p>
            </section>

            <section style={styles.section}>
                <h2 style={styles.sectionHeading}>2. How We Use Your Information</h2>
                <p style={styles.text}>
                    We use your information to process transactions, improve user experience, and ensure compliance with legal regulations.
                </p>
            </section>

            <section style={styles.section}>
                <h2 style={styles.sectionHeading}>3. Data Security</h2>
                <p style={styles.text}>
                    Your data security is our top priority. We implement best practices to protect your personal information.
                </p>
            </section>

            <footer style={styles.footer}>
                <p style={styles.footerText}>
                    For any questions or concerns, please contact us at <a href="mailto:support@vertex.com" style={styles.emailLink}>support@vertex.com</a>.
                </p>
            </footer>
        </div>
    );
};

const styles = {
    container: {
        fontFamily: "'Arial', sans-serif",
        padding: "20px",
        maxWidth: "800px",
        margin: "0 auto",
        backgroundColor: "#f9f9f9",
        boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
    },
    heading: {
        fontSize: "2rem",
        color: "#333",
        textAlign: "center",
    },
    introText: {
        fontSize: "1.1rem",
        color: "#555",
        marginBottom: "20px",
        lineHeight: "1.6",
    },
    section: {
        marginBottom: "20px",
    },
    sectionHeading: {
        fontSize: "1.5rem",
        color: "#222",
        borderBottom: "2px solid #ddd",
        paddingBottom: "5px",
        marginBottom: "10px",
    },
    text: {
        fontSize: "1rem",
        color: "#555",
        lineHeight: "1.6",
    },
    footer: {
        borderTop: "1px solid #ddd",
        paddingTop: "20px",
        textAlign: "center",
    },
    footerText: {
        fontSize: "0.9rem",
        color: "#777",
    },
    emailLink: {
        color: "#007bff",
        textDecoration: "none",
    },
};

// Mobile Responsive Styles
const mediaQuery = `
  @media (max-width: 600px) {
    h1 {
      font-size: 1.5rem;
    }
    h2 {
      font-size: 1.2rem;
    }
    p {
      font-size: 0.9rem;
    }
  }
`;

export default PrivacyPolicy;
